import { sample } from 'lodash';
import { TutorialStep, type ConfigEnemy, CurrentEnemy } from '../../../../types/alice-bob';
import { CoinsEffectPool } from '../vfx/coins/CoinsEffectPool';
import Gold from '../gui/gold/Gold';
import { setTutorialStep } from '../../../backend/store/tutorial';

const EVENTS = {
    SPAWNED: 'enemy_spawned',
    HEALTH_UPDATED: 'enemy_health_updated',
    KILLED: 'enemy_killed',
    DAMAGED: 'enemy_damaged',
} as const;

const ANIMS = {
    IDLE: 'Idle',
    DAMAGE: 'Damage',
    DAMAGE2: 'Damage2',
} as const;

export default class Enemy extends Phaser.GameObjects.Container {
    private config!: CurrentEnemy;
    private sprite!: any;
    private sprite_additional_1!: any;
    private sprite_additional_2!: any;
    private optionalSkinPrefix = '';
    public name = 'Monster';
    private hp = { current: 0, max: 0 };
    private coinsEffectPool: CoinsEffectPool;

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);
        this.scene.layers.enemy.add(this);
        this.coinsEffectPool = new CoinsEffectPool(this.scene, 10, 'gui/gold/icon', { x: Gold.globalPositionOfIcon.x, y: Gold.globalPositionOfIcon.y }, { x: 360, y: 900 })
        this.add(this.coinsEffectPool);
    }

    static get EVENTS() {
        return EVENTS;
    }

    spawn(enemy: CurrentEnemy) {
        this.config = enemy;
        this.sprite?.destroy();
        this.sprite_additional_1?.destroy();
        this.sprite_additional_2?.destroy();

        let x = this.scene.cameras.main.centerX + (enemy.enemy_shift?.x || 0);
        let y = this.scene.cameras.main.centerY - 10 + (enemy.enemy_shift?.y || 0);

        let name = this.config.enemy_name;
        this.optionalSkinPrefix = this.config.enemy_name.includes('Card_') || this.config.enemy_name.includes('Key_') ? this.config.enemy_name + '/' : '';

        if (name == 'Caterpillar') {
            this.sprite = this.scene.add.spine(x, y, name, this.optionalSkinPrefix + ANIMS.IDLE, true);
            this.add(this.sprite);

            this.sprite_additional_1 = this.scene.add.spine(x, y, name + '_Smoke1', this.optionalSkinPrefix + ANIMS.IDLE, true);
            this.add(this.sprite_additional_1);

            this.sprite_additional_2 = this.scene.add.spine(x, y, name + '_Smoke2', this.optionalSkinPrefix + ANIMS.IDLE, true);
            this.add(this.sprite_additional_2);
        } else {
            this.sprite = this.scene.add.spine(x, y, name, this.optionalSkinPrefix + ANIMS.IDLE, true);
            this.add(this.sprite);
        }

        this.sprite.setMix(this.optionalSkinPrefix + ANIMS.DAMAGE, this.optionalSkinPrefix + ANIMS.IDLE, 0.2);
        this.sprite.setMix(this.optionalSkinPrefix + ANIMS.DAMAGE2, this.optionalSkinPrefix + ANIMS.IDLE, 0.2);

        this.name = enemy.enemy_name;
        this.hp.current = enemy.hp;
        this.hp.max = enemy.hp;


        const baseName = enemy.enemy_alias || this.name;
        const nameText = enemy.is_boss ? `${baseName} (BOSS)` : baseName;


        this.scene.tweens.add({
            targets: this,
            // scale: 1,
            alpha: 1,
            duration: 300,
            ease: 'Back.easeOut', // gives a nice pop/stretch effect
            onComplete: () => {
                this.scene.events.emit(EVENTS.SPAWNED, nameText, this.hp);
            }
        });
    }

    getHit(damage: number, isCrit: boolean, heroId: number, isEnrageHit: boolean, isAura: boolean = false) {
        this.hp.current = Math.max(0, this.hp.current - damage);
        this.scene.events.emit(EVENTS.HEALTH_UPDATED, this.hp);

        setTutorialStep(TutorialStep._2_FIRST_ATTACK);

        this.scene.events.emit(EVENTS.DAMAGED, this.sprite.x, this.sprite.y, damage, isCrit, isEnrageHit, heroId, isAura);
        if (this.hp.current === 0) {
            this.coinsEffectPool.showTime();
            this.hp.current = 10000; //Dirty fix  - correct later
            this.scene.tweens.add({
                targets: this,
                // scale: 0,
                alpha: 0,
                duration: 550,
                ease: 'Cubic.easeIn',
                onComplete: () => {
                    this.scene.events.emit(EVENTS.KILLED, this.config, heroId);
                }
            });
            setTutorialStep(TutorialStep._3_FIRST_KILL);
        }

        if (isAura) return;

        // anim
        this.sprite.off('complete', this.setIdleAnim, this);
        let anim = sample([this.optionalSkinPrefix + ANIMS.DAMAGE, this.optionalSkinPrefix + ANIMS.DAMAGE2]);
        this.sprite.play(anim, false);
        this.sprite.timeScale = 2;
        this.sprite.once('complete', this.setIdleAnim, this);
    }

    setIdleAnim() {
        this.sprite.play(this.optionalSkinPrefix + ANIMS.IDLE, true);
    }
}
